import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=premium%20streetwear%20collection%20sneakers%20caps%20jackets%20and%20leather%20backpack%20arranged%20in%20stylish%20editorial%20still%20life%20on%20warm%20cream%20linen%20background%20professional%20studio%20product%20photography%20soft%20natural%20light%20high%20end%20fashion&width=1600&height=900&seq=hero-bg-1&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/75 via-background-950/55 to-background-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="px-3 py-1 bg-primary-500/20 text-primary-100 text-xs font-medium rounded-full backdrop-blur-sm border border-primary-500/30">
              {t('badge_updated')}
            </span>
            <span className="px-3 py-1 bg-background-100/20 text-background-100 text-xs font-medium rounded-full backdrop-blur-sm border border-background-100/30">
              {t('badge_independent')}
            </span>
            <span className="px-3 py-1 bg-accent-500/20 text-accent-100 text-xs font-medium rounded-full backdrop-blur-sm border border-accent-500/30">
              {t('badge_transparent')}
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            {t('hero_title')}
          </h1>
          <p className="text-lg md:text-xl text-background-100/90 leading-relaxed mb-8 max-w-2xl">
            {t('hero_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('hero_cta_explore')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href="#guides"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 text-white font-medium rounded-md border border-white/25 hover:bg-white/20 transition-colors backdrop-blur-sm whitespace-nowrap"
            >
              {t('hero_cta_guide')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}